import { useState } from "react";
import Editor from '@threeskye/editor-component-slate';
import './SlateEditor.scss';

const SlateEditor = (props) => {
	const initial = props.load;
	const [value, setValue] = useState(initial);
	return (
		<>
			<div className="threeskye-editor">
				<Editor
					readOnly={props.readOnly}
					addins={() => props.addins}
					className="editor-wrapper"
					value={value || []}
					onChange={(bits) => { props.onChange(bits); setValue(bits); }}
					toolbar={props.toolbar || { type: "full" }}
					setToolbar={props.setToolbar}
					colourOptions={props.colourOptions}
					hideToc={props.hideToc}
					pasteToAll={props.pasteToAll}
					pasteToSpecific={props.pasteToSpecific}
					pasteOptions={props.pasteOptions}
					toolbarSuppressions={props.toolbarSuppressions}
					throwToaster={props.throwToaster}
					renderFlowtingInsertMenu={props.renderFlowtingInsertMenu}
					onDrop={props.passedOnDrop}
					extensions={props.extensions}
				/>
			</div>
		</>
	)
}


export default SlateEditor;